import React, { useState, useEffect } from 'react';
import agendamentoService from '../services/agendamentoService';

const AgendaManager = () => {
  const [agendamentos, setAgendamentos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAgendamentos = async () => {
      try {
        const data = await agendamentoService.getAgendamentos();
        setAgendamentos(data);
      } catch (error) {
        console.error("Erro ao buscar agendamentos", error);
      } finally {
        setLoading(false);
      }
    };
    fetchAgendamentos();
  }, []);

  if (loading) return <p>Carregando agenda...</p>;

  return (
    <div className="list-card">
      <h3>Próximos Agendamentos</h3>
      {agendamentos.length === 0 ? (
        <p>Nenhum agendamento futuro.</p>
      ) : (
        <ul className="service-list">
          {agendamentos.map(ag => (
            <li key={ag.id}>
              <div className="service-info">
                <strong>{ag.services.nome_servico}</strong> com <span>{ag.cliente_nome}</span>
                <p>
                  {new Date(ag.data_hora_inicio).toLocaleDateString('pt-BR')}
                  {' - '}
                  {new Date(ag.data_hora_inicio).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}
                </p>
              </div>
              <div className="service-actions">
                <span className={`status-${ag.status}`}>{ag.status}</span>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AgendaManager;